<script>
    import {fade, fly} from 'svelte/transition';
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let header = '';
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<div class="modal-backdrop" transition:fade on:click={() => {dispatch('close')}}></div>

<div class="modal" transition:fly={{y: 300}}>
    <h3>{header}</h3>
    <slot />
</div>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, 0.75);
        z-index: 10;
    }

    .modal {
        position: fixed;
        left: 20%;
        top: 23vh;

        width: 60%;
        max-height: 80vh;

        border-radius: 5px;
        z-index: 100;
        overflow: hidden;

        background-color: var(--white-color);
        padding: 2rem;
    }
</style>